import { Box, Stack, SubProductTypeEnum, Text } from '@talos/kyoko';
import { memo } from 'react';

import { DealCard } from '@src/components/OMS/ManualDealTradeView/DealCard';
import type { OTCDealData } from '@src/types/OTC';

export type CancelDealDialogContentProps = {
  deal: OTCDealData;
};

/** Presentational body for the global cancel-deal confirmation dialog (split from hook for Fast Refresh). */
export const CancelDealDialogContent = memo(function CancelDealDialogContent({ deal }: CancelDealDialogContentProps) {
  let dealDisplayType: 'Deal' | 'Loan' = 'Deal';
  switch (deal.SubProductType) {
    case SubProductTypeEnum.OTCFixedRateLoan:
    case SubProductTypeEnum.OTCFloatingRateLoan:
      dealDisplayType = 'Loan';
      break;
  }
  return (
    <Stack gap="spacing12" alignItems="stretch">
      <Text textAlign="left" color="colorTextAttention">
        Are you sure you want to cancel this {dealDisplayType.toLowerCase()}?
      </Text>
      <Box maxWidth="100%">
        <DealCard deal={deal} />
      </Box>
    </Stack>
  );
});
